module.exports = __webpack_public_path__ + "img/plus.47408da8.svg";